const ATTEMPT_TYPE = {
    RUN: 'run',
    SAVE: 'save',
    AUTO_SAVE: 'auto_save',
    SUBMIT: 'submit',
    LOG: 'log',
    INTEGRITY_CHECK: 'integrity_check',
}
export default ATTEMPT_TYPE
